import { useLogRocket } from '@quadminds/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import { SignUpComponent } from '../components/SignUpComponent/SignUpComponent';
import Spinner from '../components/Spinner/Spinner';
import { useCheckInvite } from '../hooks/useCheckInvite';
import { useValidateInvite } from '../hooks/useValidateInvite';
import SignupLayout from '../layout/SignupLayout';
import { ValidatedInvite, isFleetcare, isMindy, isOms, shouldBypass } from '../utils';

const Register: React.FC = () => {
    console.log('[Register] v3 - deploy check', new Date().toISOString());
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // First check the invite
    const inviteUuid = searchParams.get('invite') || '';
    const bypassQueryParam = searchParams.get('bypass');
    const { data, isLoading } = useCheckInvite({ inviteId: inviteUuid });
    const foundInvite = data?.data ? data?.data[0] : undefined;
    useLogRocket(`Invited ${foundInvite?.email}`, foundInvite);

    // Then validate the invite
    const result = useValidateInvite(foundInvite);
    const isValid = shouldBypass(bypassQueryParam) || Object.values(result).every(Boolean);
    if (!isValid && !isLoading) {
        const errorPath = Object.keys(result).find((key) => !result[key as keyof ValidatedInvite]) ?? '';

        navigate('/error', {
            state: {
                title: `invite.errors.${errorPath}.title`,
                body: `invite.errors.${errorPath}.body`,
                img: 'error_user',
                renderCta: false,
            },
        });
    }

    // Then check if the user already exists. If so, redirect to add organization
    // const { email } = foundInvite || {};
    // const { data: existentUser } = useCheckUserExistence({ emailOrPhone: email, by: 'email' });
    // if (existentUser) {
    //     navigate('/add-organization', {
    //         state: {
    //             alreadyValidated: true,
    //         },
    //     });
    // }

    return (
        <SignupLayout>
            {!isLoading ? (
                <SignUpComponent
                    inviteUuid={inviteUuid}
                    email={foundInvite?.email || ''}
                    organizationName={foundInvite?.organization.name || ''}
                    userExternalId={foundInvite?.userExternalId}
                />
            ) : (
                <div className={`w-full h-full flex flex-col justify-center content-center items-center`}>
                    <Spinner />
                    <p className={`mt-4 animate-pulse ${isMindy || isFleetcare || isOms ? 'text-white' : ''}`}>
                        {t('invite.loading')}
                    </p>
                </div>
            )}
        </SignupLayout>
    );
};

export default Register;
